module.exports = __webpack_public_path__ + "static/media/emojiCrying.898e69c3.svg";